import { Box, Button, InputAdornment, TextField, Typography } from "@mui/material";
import { COLOR } from "../../../../utils/colors";
import { AddOutlined } from "@mui/icons-material";
import { VIEW } from "../../../../utils/breakpoint";
import { useState } from "react";
import { GridSearchIcon } from "@mui/x-data-grid";
import ListRobotTable from "../../robot/list-robot-table";
import { RobotType } from "../../../../hooks/robot/index.type";
import ListRobotMapTable from "../../robot-map/list-robot-map-table";
import { MapType } from "../../../../hooks/map.type";
import { useQueryState } from "nuqs";

export default function ListRobotMapScreen({
  onCreateNew,
  onHandleEdit,
  onSubmitRobotMaps
}: {
  onCreateNew?: () => void
  onHandleEdit?: (robotId: string) => void
  onSubmitRobotMaps?: (robots: MapType[]) => void
}) {
  const [searchTerm, setSearchTerm] = useState('')
  const [selectedRobotMaps, setSelectedRobotMaps] = useState<MapType[]>([])

  const [building_uuid] = useQueryState('building_uuid', { clearOnDefault: true })

  const isDisableNext = false;

  const onHandleUpdateSelectedRobot = (robotMaps: MapType[]) => {
    setSelectedRobotMaps(robotMaps)
  }

  const onHandleNext = () => {
    // if (selectedRobotMaps.length <= 0) {
    //   return
    // }
    onSubmitRobotMaps?.(selectedRobotMaps)
  }
  return (
    <Box sx={(theme) => ({
      paddingY: '34px',
      color: COLOR.neutral[900],
      [theme.breakpoints.up(VIEW.PHONE)]: {
        paddingX: '24px',
      },
      [theme.breakpoints.up(VIEW.TABLET)]: {
        paddingX: '44px',
      }
    })}>
      <Box sx={{ display: 'flex', flexDirection: 'column' }}>
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <Box sx={{ display: 'flex', flexDirection: 'column' }}>
            <Typography
              sx={{
                fontSize: '24px',
                fontWeight: 600,
                color: COLOR.neutral[900]
              }}
            >
              Robot Maps
            </Typography>
            <Typography
              sx={{
                fontSize: '14px',
                fontWeight: 400,
                color: COLOR.neutral[900],
                opacity: 0.6,
              }}
            >
              List of robot maps available in {!!building_uuid ? 'the selected building' : 'the system'}
            </Typography>
          </Box>
          <Button onClick={() => onCreateNew?.()} variant="outlined" startIcon={<AddOutlined />}>
            Create New
          </Button>
        </Box>
        <Box sx={{ display: 'flex', mt: '20px' }}>
          <TextField
            id="search-store-name"
            variant="outlined"
            size="small"
            placeholder='Search Robot'
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            sx={{
              flex: 'auto',
              backgroundColor: 'white',
              height: "40px",
            }}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <GridSearchIcon />
                </InputAdornment>
              ),
            }}
          />
        </Box>
      </Box>
      <ListRobotMapTable
        search={searchTerm}
        onSelectedChange={(robots) => onHandleUpdateSelectedRobot(robots)}
      />
      <Box sx={{ display: 'flex', justifyContent: 'end' }}>
        <Button onClick={onHandleNext} variant="contained" disabled={isDisableNext}>Next</Button>
      </Box>
    </Box>
  )
}